// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.no-uppercase[data-v-2f6161d8] {\n  text-transform: unset !important;\n}\n", ""]);
// Exports
module.exports = exports;
